import apiClient from '@/api/apiClient';
import { handleError, getAuthData, prepareModel, validateId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    modelForm: {},
    backDevSpecificId: '',
    isNewRecord: true,
    status: '',
  },

  getters: {
    schema: (state) => state.schema,
    modelForm: (state) => state.modelForm,
    backDevSpecificId: (state) => state.backDevSpecificId,
    isNewRecord: (state) => state.isNewRecord,
    status: (state) => state.status,
  },

  mutations: {
    SET_SCHEMA(state, schema) {
      state.schema = schema;
    },
    SET_RECORDS(state, { recordsData }) {
      state.modelForm = typeof recordsData?.modelForm === 'object' ? recordsData.modelForm : {};
      state.backDevSpecificId = recordsData?.backDevSpecificId ? recordsData.backDevSpecificId : '';
      state.isNewRecord = Boolean(recordsData?.isNewRecord);
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
  },

  actions: {
    async fetchSchema({ commit }) {
      try {
        commit('SET_STATUS', 'loading');
        const responses = await Promise.all([
          apiClient.anxADxSpecificSchema(),
          apiClient.catAffectiveReaction(),
          apiClient.catAgeInterval(),
          apiClient.catSpecAllergies(),
        ]);
        const [
          schemaRes,
          catAffectiveReaction,
          catAgeInterval,
          catSpecAllergies,
        ] = responses.map((res) => res?.data ?? {});

        if (!schemaRes.schemaForm) throw new Error('Estructura de schema inválida.');

        const schema = structuredClone(schemaRes);
        schema.schemaForm.group1.schema.spec_adoption_at_age.items = catAgeInterval.data ?? [];
        schema.schemaForm.group1.schema.spec_adoption_age_know.items = catAgeInterval.data ?? [];
        schema.schemaForm.group1.schema.spec_adoption_reaction.items =
          catAffectiveReaction.data ?? [];
        schema.schemaForm.group2.schema.i1_spec_diseases_had_age.items = catAgeInterval.data ?? [];
        schema.schemaForm.group2.schema.i2_spec_diseases_had_age.items = catAgeInterval.data ?? [];
        schema.schemaForm.group2.schema.i3_spec_diseases_had_age.items = catAgeInterval.data ?? [];
        schema.schemaForm.group2.schema.spec_allergies_id.items = catSpecAllergies.data ?? [];

        commit('SET_SCHEMA', schema);
      } catch (error) {
        handleError(error, commit);
      }
    },

    async fetchRecords({ commit, rootState }) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        const res = await apiClient.modelANxADxSpecific(clinicalHistories_id, institutions_profes_id);
        const recordsData = res?.data?.data ?? [];
        commit('SET_RECORDS', { recordsData });
        commit('SET_STATUS', 'loaded');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async createRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'create');
        const preparedModel = prepareModel(rootState, model);
        await apiClient.createANxADxSpecific(preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async updateRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'update');
        const { clinicalHistories_id } = getAuthData(rootState);
        const preparedModel = prepareModel(rootState, model);
        await apiClient.updateANxADxSpecific(clinicalHistories_id, preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async removeRecord({ commit, rootState }, { id }) {
      try {
        commit('SET_STATUS', 'remove');
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        validateId(id);
        await apiClient.deleteANxADxSpecific(id, clinicalHistories_id, institutions_profes_id);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },
  },
};
